module.exports = __webpack_public_path__ + "static/blue-circle-9a75d6d5d38848d0bac1db9c4d5dd39d.png";